import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M5 17a2 2 0 00-2 2v3.76A5.26 5.26 0 008 28v1a1 1 0 002 0v-1h12v1a1 1 0 002 0v-1a5.26 5.26 0 005-5.22V19a2 2 0 00-2-2z"/><path d="M19.05 2a4.47 4.47 0 00-5 4.09 4 4 0 00-3 3.29.51.51 0 00.5.59h6.92a.51.51 0 00.5-.59 4 4 0 00-2.88-3.24A2.41 2.41 0 0118.45 4 2.61 2.61 0 0121 6.63V17h2V6.69A4.64 4.64 0 0019.05 2z"/>';
export var BathSVG = function BathSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
BathSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(BathSVG);